/* RESPONSIBLE TEAM: team-pricing-and-packaging */
import Controller from '@ember/controller';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';

export default class TeammatesController extends Controller {
  queryParams = ['tab', 'filterType', 'filterValue'];

  @tracked tab = 'teammates';
  @tracked filterType = null as $TSFixMe;
  @tracked filterValue = null as $TSFixMe;

  declare roles: $TSFixMe;
  declare invitedAdmins: $TSFixMe;
  declare migrationState: $TSFixMe;

  get selectedTab() {
    return this.tab;
  }

  @action
  changeTab(tab: string) {
    this.set('tab', tab);
    this.tab = tab;
  }
}
